import { Theme, css } from '@emotion/react';

export type ActionListItemVariantType = 'action' | 'danger' | 'divider' | 'section';

export const menuItemStyles = (
  { spacing, colors }: Theme,
  { variant }: { variant: ActionListItemVariantType }
) => css`
  display: block;
  width: 100%;
  padding: ${spacing(1)}px ${spacing(2)}px;
  &:focus {
    outline: 5px auto -webkit-focus-ring-color;
  }
`;

export const listStyleNone = css`
  list-style: none;
`;

export const dividerStyles = ({ spacing }: Theme) => css`
  padding-inline: ${spacing(2)}px;
  ${listStyleNone}
`;
